<template>
  <ion-page>
    <router-view />
  </ion-page>
</template>

<script>
import { IonPage } from '@ionic/vue';

export default {
  name: 'ConnectorLayout',
  components: {
    IonPage
  }
};
</script>